var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconMedExam = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 64 64"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "icon-med-exam_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 161174",
  fill: "none",
  d: "M0 0h64v64H0z"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 31337",
  clipPath: "url(#icon-med-exam_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38713",
  d: "M54.857 32A22.857 22.857 0 1132 9.143 22.857 22.857 0 0154.857 32",
  fill: "#f9a23a"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38714",
  d: "M43.678 45.999h-22.73a1.588 1.588 0 01-1.588-1.588V12.037a1.588 1.588 0 011.588-1.588h22.729a1.588 1.588 0 011.588 1.588V44.41a1.588 1.588 0 01-1.588 1.588",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 161171",
  d: "M20.948 9.688h22.73a2.353 2.353 0 012.35 2.35v32.373a2.353 2.353 0 01-2.35 2.35h-22.73a2.353 2.353 0 01-2.35-2.35V12.038a2.353 2.353 0 012.35-2.35zm22.73 35.55a.827.827 0 00.826-.826V12.038a.827.827 0 00-.826-.826h-22.73a.827.827 0 00-.826.826v32.373a.827.827 0 00.826.826z",
  fill: "#29398c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 1449",
  fill: "#fff",
  d: "M23.753 16.204h16.428"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 1450",
  d: "M40.181 16.966H23.753a.762.762 0 01-.762-.762.762.762 0 01.762-.762h16.428a.762.762 0 01.762.762.762.762 0 01-.762.762z",
  fill: "#29398c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 1451",
  fill: "#fff",
  d: "M23.753 19.216h16.428"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 1452",
  d: "M40.181 19.978H23.753a.762.762 0 01-.762-.762.762.762 0 01.762-.762h16.428a.762.762 0 01.762.762.762.762 0 01-.762.762z",
  fill: "#29398c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 1453",
  fill: "#fff",
  d: "M23.753 22.228h16.428"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 1454",
  d: "M40.181 22.99H23.753a.762.762 0 01-.762-.762.762.762 0 01.762-.762h16.428a.762.762 0 01.762.762.762.762 0 01-.762.762z",
  fill: "#29398c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 1455",
  fill: "#fff",
  d: "M34.339 29.739h6.319"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 1456",
  d: "M40.658 30.502H34.34a.762.762 0 01-.762-.762.762.762 0 01.762-.762h6.318a.762.762 0 01.762.762.762.762 0 01-.762.762z",
  fill: "#29398c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 1457",
  fill: "#fff",
  d: "M37.499 32.903v-6.326"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 1458",
  d: "M37.499 33.664a.762.762 0 01-.762-.762v-6.325a.762.762 0 01.762-.762.762.762 0 01.762.762v6.325a.762.762 0 01-.762.762z",
  fill: "#29398c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 1459",
  fill: "#fff",
  d: "M23.753 37.617h16.428"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 1460",
  d: "M40.181 38.379H23.753a.762.762 0 01-.762-.762.762.762 0 01.762-.762h16.428a.762.762 0 01.762.762.762.762 0 01-.762.762z",
  fill: "#29398c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 1461",
  fill: "#fff",
  d: "M23.753 40.581h16.428"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 1462",
  d: "M40.181 41.343H23.753a.762.762 0 01-.762-.762.762.762 0 01.762-.762h16.428a.762.762 0 01.762.762.762.762 0 01-.762.762z",
  fill: "#29398c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 161172",
  fill: "#283b8c",
  d: "M23.879 26.331h6.817v6.817h-6.817z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 161173",
  d: "M23.879 25.584h6.817a.747.747 0 01.747.747v6.817a.747.747 0 01-.747.747h-6.817a.747.747 0 01-.747-.747v-6.817a.747.747 0 01.747-.747zm6.07 1.494h-5.323v5.323h5.323z",
  fill: "#283c8c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38715",
  d: "M37.517 8.095h-2.61a2.62 2.62 0 00-5.189 0h-2.612a2 2 0 00-2 2h14.411a2 2 0 00-2-2",
  fill: "#283b8c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38716",
  d: "M32.648 50.6l-2.92 6.932a.431.431 0 00.537.6l7.209-2.147 1.191-1.068-4.826-5.384z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38717",
  d: "M33.9 48.364l5.926 6.612-1.943 1.742-7.5 2.234-.275.023a1.246 1.246 0 01-1.043-.553 1.286 1.286 0 01-.1-1.214l2.992-7.1zm3.6 6.485l-3.725-4.156-.44.394-2.542 6.035 6.267-1.878z",
  fill: "#29398c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38718",
  d: "M31.018 54.681l-1.344 3.19a.2.2 0 00.247.276l3.317-.988z",
  fill: "#29398c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38719",
  d: "M30.762 53.162l3.957 4.415-4.679 1.394-.191.011a1.017 1.017 0 01-.851-.453 1.036 1.036 0 01-.086-.977zm1 3.586l-.49-.547-.337.8z",
  fill: "#29398c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38720",
  d: "M60.274 35.542l-3.083 2.765-4.827-5.385 3.083-2.763a1.379 1.379 0 011.94-.041l3.138 3.5a1.379 1.379 0 01-.251 1.922",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38721",
  d: "M57.127 39.471l-5.928-6.613 3.7-3.313a2.408 2.408 0 011.6-.63 1.984 1.984 0 011.5.653l3.137 3.5a1.981 1.981 0 01.495 1.445 2.407 2.407 0 01-.81 1.642zm-3.6-6.485l3.726 4.157 2.469-2.214a.761.761 0 00.264-.5.349.349 0 00-.076-.254l-3.138-3.5a.362.362 0 00-.274-.1.774.774 0 00-.5.209z",
  fill: "#29398c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38722",
  d: "M57.191 38.306l-19.153 17.17-4.825-5.383 19.151-17.169z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38723",
  d: "M52.428 31.757l5.927 6.613-20.38 18.268-5.926-6.611zm3.6 6.485l-3.726-4.157-17.923 16.068 3.725 4.155z",
  fill: "#29398c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 1463",
  fill: "#fff",
  d: "M36.198 52.401l13.766-12.34"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 1464",
  d: "M36.198 53.226a.822.822 0 01-.614-.274.824.824 0 01.059-1.165l13.771-12.34a.824.824 0 011.164.064.824.824 0 01-.064 1.164l-13.766 12.34a.821.821 0 01-.55.211z",
  fill: "#29398c"
}))));
export default __webpack_public_path__ + "static/icon-med-exam.6b31cfa8280e2faac0929fd605fad29b.svg";
export { SvgIconMedExam as ReactComponent };